import React from 'react';
import * as S from '../ThankYouBody/ThankYouBody.styles';

import BreadCrumb from '../BreadCrumb/BreadCrumb';
import Card from '../Card/Card';
import ThankYouInfoCard from '../InfoCard/InfoCard';
import ThankYouRightBlock from '../RightBlock/RightBlock';

const ThankYouBody = ({statusInfo, hotelDetails, roomDetails, checkinCheckoutDetail, guestDetails, cancellationPolicies,
    exclusions, contactInfo, priceInfo, fareBreakup, navigateToMyTrips, actions}) => (
  <S.ThankOuterWrap>
    <S.ThankInnerWrap>
      <S.ThankLeftOuterWrap>
        <BreadCrumb statusInfo={statusInfo} navigateToMyTrips={navigateToMyTrips} />
        <Card hotelDetails={hotelDetails} roomDetails={roomDetails} checkinCheckoutDetail={checkinCheckoutDetail}
        guestDetails={guestDetails} priceInfo={priceInfo} fareBreakup={fareBreakup} actions={actions} status={statusInfo.status}/>
        <ThankYouInfoCard cancellationPolicies={cancellationPolicies} exclusions={exclusions} />
      </S.ThankLeftOuterWrap>
      <ThankYouRightBlock contactInfo={contactInfo} navigateToMyTrips={navigateToMyTrips} />
    </S.ThankInnerWrap>
  </S.ThankOuterWrap>
);

export default ThankYouBody;
